module.exports = __webpack_public_path__ + "static/img/forests02.b86f442.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog/forests02.jpg
// module id = 6ahG
// module chunks = 0